@if (time(); as time) {
  {{ time | onyxTime }}
} @else {
  -
}
